<template>
	<div>
	<component  transition="switch"
			v-bind:is="currentComponent" 
			:loading_status="loading_status"
			:modul_data="curent_api_return"
			:reGetData="reGetData"
			:getFiletrField="getFiletrField"
			:setFiletrField="setFiletrField"
			:pushRouter="pushRouter"
			:curent_right_return="curent_right_return"
			></component>
	<!--pre>	
		{{ curent_api_return }}
	</pre-->
	
	</div>
</template>

<script>
/*
import  crmLoading from 'src/components/Our/crmLoading.vue';
import  crmMyWork from 'src/components/Our/crmMyWork.vue';
import  demandView from 'src/components/Our/demandView.vue';
import  ClientsView from 'src/components/Our/ClientsView.vue';
*/
export default {
	components: {
		//crmLoading,crmMyWork,demandView,ClientsView,
	},
	data () {
			return {
				curent_api_return:'',
				curent_right_return:'',
				loading_status:'',
				moduls_config:[],
				curentModul:'crmLoading',
				main_loading:false,
			}
	},
	created() {
		/*
		let dateBegin = new Date();
		let dateEnd = new Date();
		dateBegin.setMonth(dateBegin.getMonth() - 2);
		dateEnd.setMonth(dateEnd.getMonth() + 1);
		*/
		/* 
		Вот тут очень хитрая штука которую я придумал, что бы все было красиво и при этом нам не дергать БКН по каждой мелочи.
		Ниже поределяется массив:
		moduls_config[modul_name] = {
		dataurl:'url_reqw_json_data',
		filter:'default_post_param',
		cats:'через запятую имена всех необходимых справочников',
		render:'имя модуля который будет это все отрисовывать'
		}
		Перед загрузкой справочника сверяемся с глобальным объектом, не загружен ли он уже
		*/
		/*
		// Обращения
		this.moduls_config['demand']={
		dataurl:'/data.php/crm/storePager',
		filter:'deal_typeId=4&sorter=dateUpdate_desc&sorterDirection=desc&staffId=&structureId=&page=1&start=0&limit=25',
		cats:'staff,obj_type_demant,subway,demand_favorites_status,deal_type_filter,crm_lid_status_filter,crm_lid_media_source,crm_lid_media_source_recent,crm_media_source,crm_lid_archive_status,crm_monitoring_type,search_object,crm_lids_status,crm_lid_demand_status,crm_lid_object_status,operation_type,validate_message,railway,bool,promo,clientconttype,first_name,crm_lid_source,crm_lid_type_operation_type,demand_validate_message,regions_full,validate,export_type_demand,firmdog,client_type,client_category,crm_has_work,typeobjglobal,crm_lid_obj_type,ne,house,balcony,action,floors,arrivetype,time,slandtype,urstatus,countries,adbuilding,animals,currency,consierge,boot,decorationinnerz,degreebuild,domophone,enterhouse,decorationouterz,commercefloor,floorjoists,fridge,frontdoor,furniture,garbagetype,gas,guard,heating,hotwater,inet,infrastructure,isolation,cities,commerceland,landscape,landstatus,lease,leasetype,lift,comission_agency,oven,ownership,parking,phone,planning,power,road,roof,sewer,signalization,stateobj,subfloor,zagorodtransp,tv,countryland,wallsz,walls,washingmachine,water,wcz,windows,windowview,market,operationtype,cj_column,crm_client_status,',						
		render:'demandView',
		constraints:"(location.pathname.indexOf('app')<0 && location.pathname.indexOf('obj')<0)",
		},
		// Дела
		this.moduls_config['mywork']={
		dataurl:'/data.php/work/storePager',
		filter:'isCalendar=1&whenDateBegin='+dateBegin.toISOString().substring(0, 10)+'&whenDateEnd='+dateEnd.toISOString().substring(0, 10)+'&start=0&finish=&staffId=&structureId=&work_status=0&module=&page=1&limit=100',
		cats:'deal_type_filter,crm_work_type,crm_workfinish,crm_calltype,calendar_type,operation_type,',
		render:'crmMyWork'
		},
		//клиенты
		this.moduls_config['cc']={
			dataurl:'/data.php/clientpeople/storePager',
			filter:'&deleted=0&page=1&start=0&limit=25',
			cats:'staff,obj_type_demant,subway,demand_favorites_status,deal_type_filter,crm_lid_status_filter,crm_lid_media_source,crm_lid_media_source_recent,crm_media_source,crm_lid_archive_status,crm_monitoring_type,search_object,crm_lids_status,crm_lid_demand_status,crm_lid_object_status,operation_type,validate_message,railway,bool,promo,clientconttype,first_name,crm_lid_source,crm_lid_type_operation_type,demand_validate_message,regions_full,validate,export_type_demand,firmdog,client_type,client_category,crm_has_work,typeobjglobal,crm_lid_obj_type,ne,house,balcony,action,floors,arrivetype,time,slandtype,urstatus,countries,client_status,',
			render:'ClientsView',
			constraints:"(location.pathname.indexOf('app')<0 && location.pathname.indexOf('obj')<0)",
		},    
		this.curent_right_return='';
		this.getData();
		*/
	},
	methods:{
		/*
		getData(get_cats){
		this.main_loading=true;
		if(this.curent_right_return==''){
				this.$GVO.ApiCall('/data.php/right/get','name='+this.$route.params.menuname)
				.then((objApi) => { 
			// Результат: v - Тип просмотра(Число. NULL,1 - Все,2 - Подчиненные, 3- Только свои), r - Права(возможно несколько значение через запятую)
			this.$GVO.vsff=objApi.data.data;
			this.curent_right_return=objApi.data.data; 
			this.main_loading=false;
			return this.getData(get_cats);  
			})
				.catch((errorObjApi) => { this.main_loading=false; console.log(errorObjApi); });
				return false;
		}
		if(get_cats==undefined){get_cats=true;}
		//console.log('umenu - getData start');
		//	if(this.main_loading ){
		this.main_loading=true;
		
		this.$GVO.ApiCall('/data.php/'+this.$route.params.menuname+'/app?format=json','')
			.then((objApi) => { //alert(11); 
				this.main_loading=false;
				
				if(this.moduls_config[this.$route.params.menuname] != undefined){
				//rebuild filter
				var tmp_f_curent = this.$GVO.parseQueryString(location.search.substr(1)); 
				var tmp_f_config = this.getFiletrField(); 
				for(var tmp_v in tmp_f_curent){
					tmp_f_config[tmp_v]=tmp_f_curent[tmp_v];
				}
				this.setFiletrField(this.$GVO.ObjToQueryString(tmp_f_config));
				
				// load cats    
				//this.loading_status='Загрузка справочников - start<br>';
				if(get_cats){			
					var cat_names_arr = this.moduls_config[this.$route.params.menuname].cats.split(',');
					for(var cat_name in cat_names_arr){ 
					this.$GVO.loadCat(cat_names_arr[cat_name]);
					// this.loading_status=this.loading_status+cat_names_arr[cat_name]+' - OK <br>';
					}
					this.loading_status+='Загрузка справочников - OK<br>Получение данных...<br>';
				}
				//console.log(' CHECK COUNTER !!!!!  = '+this.$GVO.cats_loading_counter);
				if(this.$GVO.cats_loading_counter > 0){ console.log('reget data');  return this.getData(false);	}
				//load main data
				if(
					this.moduls_config[this.$route.params.menuname].constraints!='' &&
					eval(this.moduls_config[this.$route.params.menuname].constraints)
				){
					//console.log(this.curent_api_return);
					this.curent_api_return={total:0,rows:[]}
					this.curentModul=this.moduls_config[this.$route.params.menuname].render;
					return true;
				}

				this.$GVO.ApiCall(this.moduls_config[this.$route.params.menuname].dataurl,this.moduls_config[this.$route.params.menuname].filter)
					.then((objApi) => {
					if(objApi.data.success==true||objApi.data.success=='true'||objApi.data.success==1){ //console.log(objApi.data);
						objApi.data.config = this.moduls_config[this.$route.params.menuname];
						this.curent_api_return=objApi.data;
						this.curentModul=this.moduls_config[this.$route.params.menuname].render;
					}
					})
					.catch(errorObjApi => {console.error(errorObjApi); this.loading_status+='<b>Критическая ошибка - не удалось получить основные данные</b><br>';} );
				}else{ this.curent_api_return = objApi.data; }
			})
			.catch((errorObjApi) => {this.main_loading=false; console.error(errorObjApi); } );
			
			//	}
		},
		reGetData(p){
			//console.log(this.moduls_config[this.$route.params.menuname].filter);
		this.getData(p);
			//console.log(this.moduls_config[this.$route.params.menuname].filter);	
		},
		getFiletrField(){
			return this.$GVO.parseQueryString(this.moduls_config[this.$route.params.menuname].filter);
		},
		setFiletrField(in_str){
			this.moduls_config[this.$route.params.menuname].filter = in_str;
		},
		pushRouter(vurl){
			this.$router.push({path: vurl});
		},
		*/
	},
	computed: {
			currentComponent:function(){
				return this.curentModul;
			}
	},
	watch: {

	},
	mounted(){

	},
}

</script>

<style scoped>
.switch-transition {
	transition: all .5s ease-in-out;
}

.switch-enter {
	left: 100%;
}

.switch-leave {
	left: -100%;
}

</style>
